// ============================================================================
// OBT F3-C — Raporlama / analitik API katmanı (paket-yerel, SALT-OKUNUR)
// ============================================================================
// Tüm yollar backend `modules/obt/api.py` ile doğrulanmıştır (dual-mount
// `/obt` → /api + /api/v1). Aktör kimliği HİÇBİR çağrıda body/query ile
// GÖNDERİLMEZ; kapsam backend'de JWT + ChainService ile çözülür (vekâlet
// kapsamı GENİŞLETMEZ).
//
// Doğrulanmış sözleşme (özet):
//   GET /obt/campaigns?topic&status&park_id&only_late&limit&offset → CampaignHistoryPage
//   GET /obt/campaigns/{id}                                        → CampaignHistoryOut
//   GET /obt/campaigns/{id}/response-summary                       → ResponseStatusSummaryOut
//   GET /obt/campaigns/{id}/durations                             → ReviewDurationSummaryOut
//   GET /obt/campaigns/{id}/pending?limit&offset                  → RespondentStatusPage
//   GET /obt/campaigns/{id}/late?limit&offset                     → RespondentStatusPage
//   GET /obt/campaigns/{id}/decision-sets                         → DecisionSetHistoryOut
//   GET /obt/campaigns/{id}/timeline?limit&offset                 → TimelinePage
//   GET /obt/parks/{id}/history?limit&offset                      → ParkObtHistoryOut
//   GET /obt/topics/history?topic&limit&offset                    → TopicHistoryOut
// ============================================================================

import apiClient from '@/api/client';

const OBT = '/obt';
const enc = encodeURIComponent;

function pageParams({ limit, offset } = {}) {
  const params = {};
  if (typeof limit === 'number') params.limit = limit;
  if (typeof offset === 'number') params.offset = offset;
  return params;
}

export async function fetchCampaignPage(
  { topic, status, parkId, onlyLate, limit, offset } = {},
  { signal } = {}
) {
  const params = pageParams({ limit, offset });
  if (topic) params.topic = topic;
  if (status) params.status = status;
  if (parkId) params.park_id = parkId;
  if (onlyLate) params.only_late = true;
  const res = await apiClient.get(`${OBT}/campaigns`, { params, signal });
  return res.data; // { page, items: CampaignHistoryOut[] }
}

export async function fetchCampaignSummary(campaignId, { signal } = {}) {
  const res = await apiClient.get(`${OBT}/campaigns/${enc(campaignId)}`, { signal });
  return res.data; // CampaignHistoryOut (description dahil)
}

export async function fetchResponseSummary(campaignId, { signal } = {}) {
  const res = await apiClient.get(
    `${OBT}/campaigns/${enc(campaignId)}/response-summary`,
    { signal }
  );
  return res.data; // { campaign_id, by_status, by_review_state, by_scope_source, total }
}

export async function fetchReviewDurations(campaignId, { signal } = {}) {
  const res = await apiClient.get(
    `${OBT}/campaigns/${enc(campaignId)}/durations`,
    { signal }
  );
  return res.data; // { campaign_id, computed_at, stages: DurationStatOut[] }
}

export async function fetchPendingRespondents(campaignId, { limit, offset } = {}, { signal } = {}) {
  const res = await apiClient.get(`${OBT}/campaigns/${enc(campaignId)}/pending`, {
    params: pageParams({ limit, offset }),
    signal,
  });
  return res.data; // RespondentStatusPage
}

export async function fetchLateRespondents(campaignId, { limit, offset } = {}, { signal } = {}) {
  const res = await apiClient.get(`${OBT}/campaigns/${enc(campaignId)}/late`, {
    params: pageParams({ limit, offset }),
    signal,
  });
  return res.data; // RespondentStatusPage
}

export async function fetchDecisionSetHistory(campaignId, { signal } = {}) {
  const res = await apiClient.get(
    `${OBT}/campaigns/${enc(campaignId)}/decision-sets`,
    { signal }
  );
  return res.data; // { campaign_id, versions: [...] }
}

export async function fetchCampaignTimeline(campaignId, { limit, offset } = {}, { signal } = {}) {
  const res = await apiClient.get(`${OBT}/campaigns/${enc(campaignId)}/timeline`, {
    params: pageParams({ limit, offset }),
    signal,
  });
  return res.data; // TimelinePage
}

export async function fetchParkHistory(parkId, { limit, offset } = {}, { signal } = {}) {
  const res = await apiClient.get(`${OBT}/parks/${enc(parkId)}/history`, {
    params: pageParams({ limit, offset }),
    signal,
  });
  return res.data; // ParkObtHistoryOut
}

export async function fetchTopicHistory({ topic, limit, offset } = {}, { signal } = {}) {
  const params = pageParams({ limit, offset });
  if (topic) params.topic = topic;
  const res = await apiClient.get(`${OBT}/topics/history`, { params, signal });
  return res.data; // TopicHistoryOut
}
